<ion-app>
  <router-outlet></router-outlet>
  <app-instant-feedback-button *ngIf="isInstantFeedbackEnabled" />
  <ion-progress-bar *ngIf="showIdleTimer" [value]="timeToIdleProgress" />
</ion-app>
